import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectQuizResult } from 'modules/landing/selectors';
import TrialForm from '../../components/trial-form';
import useLandingType from 'hooks/useLandingType';
import { QuizSectionDescription } from 'components/quiz/components';
import { TransitionQuizResults } from 'modules/transition-quiz/results';
import TransitionChallengeMap from 'modules/transition-quiz-result/challenge-map';

const TransitionQuizTrial = () => {
  const landingType = useLandingType();
  const result = useSelector(selectQuizResult(landingType));
  const challenge = useMemo(() => {
    const resultIndex = result
      ? (result as TransitionQuizResults)
      : TransitionQuizResults.CHOICE;
    return TransitionChallengeMap[resultIndex];
  }, [result]);

  return (
    <>
      <QuizSectionDescription>
        {`Please complete the following fields in order to be able to start your
        free trial of the challenge ${challenge.title}.`}
      </QuizSectionDescription>
      <TrialForm buttonText="Become Your Best" />
    </>
  );
};

export default TransitionQuizTrial;
